import { isValid } from 'date-fns/isValid'
import { parseISO } from 'date-fns/parseISO'

import { parseServiceDate } from '../MenuHeader/ServiceSelectionGraphql/serviceWeeks'

export function serializeMenuQueryDate(value: string, timezone?: string | null): string | null {
  const date = timezone ? parseServiceDate(value, timezone) : parseISO(value)
  // Legacy query serialization sends null for an invalid selection.
  return isValid(date) ? date.toISOString() : null
}
